import React from 'react';
import styled from 'styled-components';
import {Typography} from '@fupa/fupa-uikit';

const HintTypography = styled(Typography)`
  &&& {
    text-decoration: underline;
    color: inherit;
    cursor: pointer;
  }
`;

export default function LoginHint() {
  const handleLoginClick = () => {
    // @ts-ignore
    window.location = `/auth/login?redirectUrl=${encodeURIComponent(window.location.pathname)}`;
  };

  return (
    <span onClick={handleLoginClick}>
      <HintTypography variant='caption-error'>Hier geht's zum Login</HintTypography>
    </span>
  );
}
